import React from 'react';
import PropTypes from 'prop-types';
import { Pie } from '@ant-design/charts';

const SimpleDonutChart = ({ title, total, data }) => {
  if (!data || data.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: 20 }}>Aucune donnée</div>
    );
  }

  const config = {
    data,
    angleField: 'count',
    colorField: 'item',
    color: ['#80C0E9', '#4F518C', '#FAA613', '#F4E04D'],
    radius: 0.8,
    innerRadius: 0.75,
    label: {
      type: 'inner',
      offset: '-50%',
      content: '{percentage}',
      style: {
        textAlign: 'center',
        fontSize: 14
      }
    },
    legend: {
      position: 'bottom'
    },
    tooltip: {
      title: title,
      showMarkers: true
    },
    pieStyle: {
      lineWidth: 2,
      stroke: '#fff'
    },
    statistic: {
      title: {
        offsetY: -8,
        style: {
          fontSize: title.length > 12 ? '14px' : '20px',
          fontFamily: 'PT Sans',
          color: '#333333'
        },
        content: title
      },
      content: {
        offsetY: 4,
        style: {
          fontSize: '30px',
          fontWeight: 'bold',
          fontFamily: 'PT Sans',
          color: '#333333'
        },
        content: String(total)
      }
    },
    interactions: [
      {
        type: 'element-selected'
      }
    ],
    autoFit: true,
    height: 240
  };

  return (
    <div style={{ width: '100%', height: '240px' }}>
      <Pie {...config} />
    </div>
  );
};

SimpleDonutChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.string,
      count: PropTypes.number
    })
  ),
  title: PropTypes.string,
  total: PropTypes.number
};

SimpleDonutChart.defaultProps = {
  data: undefined,
  title: 'Chart',
  total: 0
};

export { SimpleDonutChart };
